export const fetchCategories = (roleId, search = '') =>
    fetch(`${process.env.REACT_APP_API_URL}/api/app/search/work-order-categories`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            roleId,
            search
        })
    })
        .then(resp => resp.json())
        .then(resp => resp.results.sort()
            .map(r => ({label: r, value: r}))
        ).catch(console.error);
